import React, { useEffect, useState } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import "./App.css";
import LoginPage from "./pages/login/Login";
import PrivateRoute from "./components/PrivateRoute";
import SessionTimeout from "./components/SessionTimeout";
import DashboardLayout from "./pages/dashboard/DashboardLayout";
import DashboardRightSection from "./components/dashboardComponent/DashboardRightSection";
import SelectedSession from "./components/dashboardComponent/SelectedSession";
import MedicalDictionary from "./pages/medicalDictionary/dictionary";
import useUserStore from "./store/useUserStore";
import ManualLogin from './pages/login/ManualLogin'
import SelectedSurgicalSession from "./components/dashboardComponent/SelectedSurgicalSession";
import ResetPassword from "./components/loginComponent/ResetPassword";

function App() {
  const { setIsMobile,isMobile} = useUserStore();
  const [email, setEmail] = useState("")
  const [password, setPassword] = useState("")
  

  useEffect(() => {
      const handleResize = () => {
        setIsMobile(window.innerWidth < 600);
      };
      handleResize();
    }, [window.innerWidth]);

    
  return (
    <BrowserRouter>
      <SessionTimeout />
      <Routes>
        <Route path="/" element={<LoginPage/>} />
        <Route path="/manual-login" element={<ManualLogin email={email} setEmail={setEmail} password={password} setPassword={setPassword} />}/>
        <Route path="/reset-password" element={<ResetPassword email={email} password={password}/>}/>
        <Route path="/dashboard" element={<PrivateRoute>
            <DashboardLayout />
          </PrivateRoute>}>
          <Route index element={<DashboardRightSection />} />
          <Route path="selected-session" element={<SelectedSession/>} />
          <Route path="selected-surgical-session" element={<SelectedSurgicalSession />} />
          <Route path="dictionary" element={<MedicalDictionary />} />
          {/* <Route path="profile" element={<Profile />} /> */}
        </Route>

      </Routes>
    </BrowserRouter>
  );
}

export default App;